<template>
  <v-main v-if="isFound">
    <v-container fluid>
      <v-alert id="alert" v-model="alert.isAlert" :type="alert.type" closable class="row">{{ alert.message }}</v-alert>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-card-title>パスワード設定</v-card-title>
            <v-card-subtitle>
              <strong id="userId" class="text-red-lighten-1">{{ userId }}</strong> のパスワードを設定します。
            </v-card-subtitle>
            <v-card-text>
              <v-form>
                <v-text-field
                  id="newPassword"
                  v-model="newPassword"
                  :prepend-icon="mdiLock"
                  placeholder="新しいパスワード"
                  type="password"
                  variant="underlined"
                  @keyup.enter="register"
                ></v-text-field>
                <v-text-field
                  id="confirmPassword"
                  v-model="confirmPassword"
                  :prepend-icon="mdiLock"
                  placeholder="新しいパスワード(確認用)"
                  type="password"
                  variant="underlined"
                  @keyup.enter="register"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn id="cancel" variant="elevated" class="mr-10 mb-10" @click="cancel">キャンセル</v-btn>
              <v-btn id="register" variant="elevated" class="ml-10 mb-10" color="primary" :disabled="isButtonDisabled" @click="register">登録</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <v-card class="elevation-12">
            <v-card-text>
              文字数は8文字～25文字以下、文字種は半角英大文字、半角英小文字および半角数字の3種類が必ず含まれている必要があります。 <br />
              使用可能な記号は「@（アットマーク）」、「_（アンダースコア）」、「-（ハイフン）」、「#（シャープ）」のみです。
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
  <NotFound v-else-if="isNotFound" />
  <div v-else />
</template>

<script>
import NotFound from '@/views/NotFound';
import Api from '@/constants/api';
import UserRole from '@/constants/userrole';
import { mdiLock } from '@mdi/js';
import { useAlertStore } from '../stores/alert';

export default {
  components: {
    NotFound,
  },
  props: {
    hash: {
      type: String,
    },
  },
  setup() {
    const alertState = useAlertStore();
    return {
      alertState,
    };
  },
  data: () => ({
    userId: '',
    userEmail: '',
    newPassword: '',
    confirmPassword: '',
    isFound: false,
    isNotFound: false,
    isButtonDisabled: false,
    alert: {
      isAlert: false,
      type: 'success',
      message: '',
    },
    mdiLock,
  }),
  created: async function () {
    let hashResponse = await this.axios.get(Api.PATH_ACCOUNT_HASH + '/' + this.hash, {
      params: {
        hash: this.hash,
      },
    });
    if (hashResponse.data.status == Api.STATUS_SUCCESS) {
      this.userId = hashResponse.data.account.mypage_user_id;
      this.userEmail = hashResponse.data.account.mypage_user_email;
      this.isFound = true;
    } else {
      this.isNotFound = true;
    }
  },

  methods: {
    register: async function () {
      this.isButtonDisabled = true;
      try {
        let valmsg = this.validate();
        if (valmsg) {
          this.showAlert('warning', valmsg);
          return;
        }
        let passwordResponse = await this.axios.post(Api.PATH_PASSWORD_RESET, {
          mypage_user_id: this.userId,
          mypage_user_email: this.userEmail,
          mypage_user_password: this.newPassword,
          hash: this.hash,
        });
        if (passwordResponse != null && passwordResponse.data != null) {
          if (passwordResponse.data.status == Api.STATUS_SUCCESS) {
            let loginResponse = await this.axios.post(Api.PATH_LOGIN, {
              mypage_user_id: this.userId,
              mypage_user_password: this.newPassword,
            });
            if (loginResponse != null && loginResponse.data != null) {
              if (loginResponse.data.status == Api.STATUS_SUCCESS) {
                this.$cookies.set('access_token', loginResponse.data.access_token);
                if (loginResponse.data.role_id == UserRole.BILLINGUSER) {
                  this.$router.push({ name: 'InvoicesList' });
                } else {
                  sessionStorage.setItem('is_first_login', true);
                  this.$router.push({ name: 'BillingsList' });
                }
              } else if (loginResponse.data.status == Api.STATUS_ACCOUNT_LOCKED) {
                this.alertState.createAlert('warning', 'このログインIDはロックされています。');
                this.$router.push({ name: 'Login' });
              } else {
                this.alertState.createAlert('warning', 'ログインID又はパスワードが正しくありません。');
                this.$router.push({ name: 'Login' });
              }
            } else {
              throw 'API_LOGIN failed.';
            }
          } else {
            this.alertState.createAlert('error', 'パスワード登録に失敗しました。');
            this.$router.push({ name: 'Login' });
            // 上記はログイン画面への遷移は不要ではないか？
            // this.showAlert('error', 'パスワード登録に失敗しました。');
          }
        } else {
          throw 'API_PASSWORD failed.';
        }
      } finally {
        this.newPassword = '';
        this.confirmPassword = '';
        this.isButtonDisabled = false;
      }
    },
    cancel: function () {
      this.$router.push({ name: 'Login' });
    },
    validate: function () {
      let valmsg = '';
      if (!this.newPassword) {
        valmsg = '新しいパスワードを入力してください。';
        return valmsg;
      }
      if (!this.confirmPassword) {
        valmsg = '新しいパスワード(確認用)を入力してください。';
        return valmsg;
      }
      if (!/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\-@_#]{8,25}$/.test(this.newPassword)) {
        valmsg =
          '文字数は8文字～25文字以下、文字種は半角英大文字、半角英小文字および半角数字の3種類が必ず含まれている必要があります。\n使用可能な記号は「@（アットマーク）」、「_（アンダースコア）」、「-（ハイフン）」、「#（シャープ）」のみです。';
        return valmsg;
      }
      if (this.newPassword != this.confirmPassword) {
        valmsg = 'パスワードとパスワード(確認用)が不一致です。';
        return valmsg;
      }
      return valmsg;
    },
    showAlert: function (type, message) {
      this.alert.isAlert = true;
      this.alert.type = type;
      this.alert.message = message;
    },
  },
};
</script>
<style>
#alert .v-alert__content {
  white-space: pre-wrap;
}
</style>
